import { selectBalancingRelatedBuildings } from "../balancingSelectors/selectBalancingBuildings";
import { selectBalancingRecipe } from "../balancingSelectors/selectBalancingRecipes";
import { IdPersistence } from "../constants/IdPersistence";
import { utilPersistence } from "./utilPersistence";
var UtilProduction = /** @class */ (function () {
    function UtilProduction() {
        this.costsTypeMatchesRecipeId = function (baseRecipe) { return function (otherRecipeId) {
            var otherRecipe = selectBalancingRecipe(otherRecipeId);
            var isRecipeInvalid = otherRecipe == undefined || otherRecipe.cost == undefined;
            var numberOfCostsMatches = otherRecipe != undefined &&
                otherRecipe.cost != undefined &&
                otherRecipe.cost.length === baseRecipe.cost.length;
            if (isRecipeInvalid || !numberOfCostsMatches) {
                return false;
            }
            return otherRecipe.cost.every(function (otherCost) {
                return baseRecipe.cost.find(function (researchedCost) {
                    return researchedCost.resourceId === otherCost.resourceId;
                }) != undefined;
            });
        }; };
    }
    UtilProduction.prototype.setProductionRecipe = function (recipeId, buildingId) {
        var _this = this;
        var valueToSet = {};
        var otherBuildings = selectBalancingRelatedBuildings(buildingId);
        otherBuildings.forEach(function (element) {
            valueToSet[element.id] = { recipeId: _this.findRelatedRecipe(recipeId, element) };
        });
        utilPersistence.setValue(IdPersistence.LastProduction, valueToSet);
    };
    UtilProduction.prototype.findRelatedRecipe = function (recipeId, otherBuilding) {
        var recipe = selectBalancingRecipe(recipeId);
        var isRecipeValid = recipe != undefined && recipe.cost != undefined;
        var isBuildingValid = otherBuilding != undefined && otherBuilding.stage[0] != undefined;
        if (!isRecipeValid || !isBuildingValid) {
            return 0;
        }
        var otherRecipes = otherBuilding.stage[0].recipeIDs || "";
        var convertedOtherRecipes = otherRecipes
            .split(",")
            .map(function (stringToConvert) { return parseInt(stringToConvert, 10); });
        return this.findMatchingRecipe(recipe, convertedOtherRecipes) || 0;
    };
    UtilProduction.prototype.findMatchingRecipe = function (baseRecipe, comparedRecipeIds) {
        var id = comparedRecipeIds.find(this.costsTypeMatchesRecipeId(baseRecipe));
        return id || 0;
    };
    return UtilProduction;
}());
export var utilProduction = new UtilProduction();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilProduction.ts
// module id = 354
// module chunks = 3